import React, { useEffect, useState } from "react";
import axios from "axios";
import {
  Box,
  Table,
  Tbody,
  Td,
  Th,
  Thead,
  Tr,
  Button,
  Spinner,
  Flex,
  Stack,
  Link,
  Text,
  Select,
  FormControl,
  VStack,
  Input,
} from "@chakra-ui/react";
import { BASE_URL } from "../../../Globalapi/Globalapi";

const Result_admin_view = () => {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [events, setEvents] = useState([]);
  const [categories, setCategories] = useState([]);
  const [filteredCategories, setFilteredCategories] = useState([]);
  const [filteredSubCategories, setFilteredSubCategories] = useState([]);
  const [subCategories, setSubCategories] = useState([]);
  const [rowsPerPage, setRowsPerPage] = useState(10);

  // States for filtering
  const [searchTerm, setSearchTerm] = useState("");
  const [selectedEvent, setSelectedEvent] = useState("");
  const [selectedCategory, setSelectedCategory] = useState("");
  const [selectedSubCategory, setSelectedSubCategory] = useState("");

  const schoolId = sessionStorage.getItem("school_id"); // Replace with the appropriate `school_id`

  // Pagination logic
  const totalPages = Math.ceil(filteredCategories.length / rowsPerPage);
  const [currentPage, setCurrentPage] = useState(1);
  const indexOfLastRow = currentPage * rowsPerPage;
  const indexOfFirstRow = indexOfLastRow - rowsPerPage;
  const paginatedCategories = filteredCategories.slice(
    indexOfFirstRow,
    indexOfLastRow
  );

  const handlePageChange = (page) => {
    if (page >= 1 && page <= totalPages) {
      setCurrentPage(page);
    }
  };
  useEffect(() => {
    // Fetch main data
    const fetchData = async () => {
      try {
        const response = await axios.get(
          `${BASE_URL}/admin/events/registration/list_reg.php`,
          { params: { school_id: schoolId } }
        );
        console.log("res", response);

        const filteredData = response.data.data.filter(
          (item) =>
            item.price_allocation === "1" || item.price_allocation === "2"
        );
        setData(filteredData);
      } catch (err) {
        setError("Failed to fetch data. Please try again later.");
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, [schoolId]);

  useEffect(() => {
    // Fetch events
    const fetchEvents = async () => {
      try {
        const response = await axios.get(
          `${BASE_URL}/admin/events/event/list_all_event.php?school_id=${schoolId}`
        );
        setEvents(response.data.data.events || []);
      } catch (err) {
        console.error("Error fetching events:", err);
      }
    };

    // Fetch categories
    const fetchCategories = async () => {
      try {
        const response = await axios.get(
          `${BASE_URL}/admin/events/category/list_category.php?school_id=${schoolId}`
        );
        setCategories(response.data.data || []);
        console.log("res catgry:", response.data);
      } catch (err) {
        console.error("Error fetching categories:", err);
      }
    };

    // Fetch subcategories
    const fetchSubCategories = async () => {
      try {
        const response = await axios.get(
          `${BASE_URL}/admin/events/sub_category/list_subcat.php`,
          { params: { school_id: schoolId } }
        );
        setSubCategories(response.data.data || []);
      } catch (err) {
        console.error("Error fetching subcategories:", err);
      }
    };
    fetchEvents();
    fetchCategories();
    fetchSubCategories();
  }, [schoolId]);

  // Handle event filter
  const handleEventFilter = (e) => {
    const event = e.target.value;
    setSelectedEvent(event);

    // Filter categories based on selected event
    const categoriesForEvent = categories.filter(
      (category) => category.event_title === event
    );
    setFilteredCategories(categoriesForEvent);

    // Reset category and subcategory selections
    setSelectedCategory("");
    setSelectedSubCategory("");
    setFilteredSubCategories([]);
  };

  // Handle category filter
  const handleCategoryFilter = (e) => {
    const category = e.target.value;
    setSelectedCategory(category);

    // Filter sub-categories based on the selected category
    const subCategoriesForCategory = data
      .filter((student) => student.category === category)
      .map((student) => student.sub_category);
    setFilteredSubCategories(Array.from(new Set(subCategoriesForCategory)));
    setSelectedSubCategory(""); // Reset sub-category when category changes
  };

  // Handle subcategory filter
  const handleSubCategoryFilter = (e) => {
    setSelectedSubCategory(e.target.value);
  };

  // Filter data based on selected filters
  const filteredData = data.filter((item) => {
    const matchesSearch = item.student_name
      .toLowerCase()
      .includes(searchTerm.toLowerCase());
    const matchesEvent =
      selectedEvent === "" || item.event_title === selectedEvent;
    const matchesCategory =
      selectedCategory === "" || item.category === selectedCategory;
    const matchesSubCategory =
      selectedSubCategory === "" || item.sub_category === selectedSubCategory;

    return (
      matchesSearch && matchesEvent && matchesCategory && matchesSubCategory
    );
  });

  const getPrizeLabel = (priceAllocation) => {
    switch (priceAllocation) {
      case "1":
        return "First Prize";
      case "2":
        return "Second Prize";
      default:
        return "None";
    }
  };

  if (loading) {
    return (
      <Box p={4} textAlign="center">
        <Spinner size="xl" />
        <Text mt={2}>Loading...</Text>
      </Box>
    );
  }

  if (error) {
    return (
      <Box p={4} textAlign="center">
        <Text color="red.500">{error}</Text>
      </Box>
    );
  }

  return (
    <Box>
      <div className="teacher-list-container">
        <div
          className="header"
          style={{ display: "flex", alignItems: "center" }}
        >
          <h1 style={{ fontSize: "20px", margin: 0 }}>Awards</h1>
        </div>

        <Box className="breadcrumb">
          <Link
            to="/admin"
            style={{ textDecoration: "none", color: "inherit" }}
          >
            <span>Dashboard</span>
          </Link>{" "}
          / <span>Event </span> /
          <Link
            // to="/class/classlist"
            style={{ textDecoration: "none", color: "inherit" }}
          >
            <span>Awards </span>
          </Link>
        </Box>
      </div>
      <Box p={6}>
        <Flex
          direction={{ base: "column", md: "row" }} // Stack vertically on small screens, horizontally on larger screens
          justify="flex-end"
          align="center"
          p={3}
          className="sb"
        >
          <Stack direction="row" spacing={4} mb={{ base: 4, md: 0 }}>
            {" "}
            {/* Adjust spacing for smaller screens */}
            <Flex align="center">
              <Select
                // width="100%"
                width={{ base: "280px", sm: "100px" }} // Full width on mobile, fixed width on larger screens
                value={rowsPerPage}
                onChange={(e) => setRowsPerPage(Number(e.target.value))}
                borderColor="#E9EDF4"
              >
                <option value={10}>10</option>
                <option value={20}>20</option>
                <option value={50}>50</option>
              </Select>
            </Flex>
          </Stack>

          {/* Search and Filters */}
          <Box
            display="flex"
            flexWrap={{ base: "wrap", md: "nowrap" }} // Wrap on small screens, no wrap on larger
            justifyContent="flex-end"
            gap={4}
            width="100%"
            marginLeft="auto" // Aligns content to the right
          >
            {/* Search Bar */}
            <FormControl width={{ base: "100%", sm: "250px" }}>
              {" "}
              {/* Full width on mobile, fixed width on larger */}
              <Input
                placeholder="Search by name"
                value={searchTerm}
                onChange={(e) => setSearchTerm(e.target.value)}
              />
            </FormControl>

            {/* Event Filter */}
            <FormControl width={{ base: "100%", sm: "250px" }}>
              {" "}
              {/* Full width on mobile, fixed width on larger */}
              <Select
                placeholder="Select Event"
                value={selectedEvent}
                onChange={handleEventFilter}
              >
                {events.map((event) => (
                  <option key={event.id} value={event.title}>
                    {event.event_title}
                  </option>
                ))}
              </Select>
            </FormControl>

            {/* Category Filter */}
            <FormControl
              width={{ base: "100%", sm: "250px" }}
              isDisabled={!selectedEvent}
            >
              <Select
                placeholder="Select Category"
                value={selectedCategory}
                onChange={handleCategoryFilter}
              >
                {filteredCategories.map((category) => (
                  <option key={category.id} value={category.name}>
                    {category.category}
                  </option>
                ))}
              </Select>
            </FormControl>

            {/* Sub-Category Filter */}
            <FormControl
              width={{ base: "100%", sm: "250px" }}
              isDisabled={!selectedCategory}
            >
              <Select
                placeholder="Select Sub-Category"
                value={selectedSubCategory}
                onChange={handleSubCategoryFilter}
              >
                {filteredSubCategories.map((subCategory) => (
                  <option key={subCategory} value={subCategory}>
                    {subCategory}
                  </option>
                ))}
              </Select>
            </FormControl>
          </Box>
        </Flex>

        <VStack align="stretch">
          <Box overflowX="auto" maxWidth="100%">
            <Table
              sx={{
                "tbody tr:nth-of-type(even)": { backgroundColor: "#f2f4f8" },
                "th, td": {
                  textAlign: "center",
                },
              }}
              overflowX="auto "
            >
              <Thead>
                <Tr>
                  <Th>Student Name</Th>
                  <Th>Event Title</Th>
                  <Th>Category</Th>
                  <Th>Subcategory</Th>
                  <Th>Class</Th>
                  <Th>Division</Th>
                  <Th>Prize</Th>
                </Tr>
              </Thead>
              <Tbody>
                {filteredData.map((item) => (
                  <Tr key={item.id}>
                    <Td> {item.student_name}</Td>
                    <Td>{item.event_title}</Td>
                    <Td>{item.category}</Td>
                    <Td>{item.sub_category}</Td>
                    <Td>{item.class}</Td>
                    <Td>{item.division}</Td>
                    <Td>{getPrizeLabel(item.price_allocation)}</Td>
                  </Tr>
                ))}
              </Tbody>
            </Table>
          </Box>

          <Flex justify="end" borderTopWidth="1px" className="sb2" p={3}>
            <Button
              onClick={() => handlePageChange(currentPage - 1)}
              isDisabled={currentPage === 1}
            >
              Prev
            </Button>
            <Stack direction="row" mx={2}>
              {currentPage > 1 && (
                <>
                  <Button onClick={() => handlePageChange(1)}>1</Button>
                  {currentPage > 2 && <Text>...</Text>}
                </>
              )}
              <Button backgroundColor="teal" color="white">
                {currentPage}
              </Button>
              {currentPage < totalPages - 1 && (
                <>
                  <Text>...</Text>
                  <Button onClick={() => handlePageChange(totalPages)}>
                    {totalPages}
                  </Button>
                </>
              )}
            </Stack>
            <Button
              onClick={() => handlePageChange(currentPage + 1)}
              isDisabled={currentPage === totalPages}
            >
              Next
            </Button>
          </Flex>
        </VStack>
      </Box>
    </Box>
  );
};

export default Result_admin_view;
